import { z } from 'zod';
/**
 * Les enums sont déclarés ici et nulle part ailleurs : Prisma les recopie dans son schéma,
 * le front les importe pour ses listes déroulantes. Une seule source de vérité.
 */
/**
 * Les trois rôles du cercle, du plus étendu au plus commun.
 *
 * `BOUILLEUR` est l'ancien `MEMBER` renommé : c'est le rôle de base, celui que reçoit
 * toute invitation acceptée. `MAITRE_DE_CHAI` s'intercale — il conduit les séances et
 * gère les membres, mais ne touche ni aux réglages du cercle, ni à la suppression d'un
 * membre, ni à la nomination de ses pairs.
 *
 * Qui a le droit de quoi ne se lit pas ici mais dans `permissions.ts` : une liste de
 * rôles recopiée sur chaque route se périme au premier rôle suivant.
 */
export const MEMBER_ROLES = ['ADMIN', 'MAITRE_DE_CHAI', 'BOUILLEUR'];
export const memberRoleSchema = z.enum(MEMBER_ROLES);
export const MEMBER_ROLE_LABELS = {
    ADMIN: 'Fondateur',
    MAITRE_DE_CHAI: 'Maître de chai',
    BOUILLEUR: 'Bouilleur',
};
export const MEMBER_STATUSES = ['ACTIVE', 'DISABLED'];
export const memberStatusSchema = z.enum(MEMBER_STATUSES);
export const RUM_TYPES = ['AGRICOLE', 'MELASSE', 'PUR_JUS', 'AUTRE'];
export const rumTypeSchema = z.enum(RUM_TYPES);
/** Libellés français des types, utilisés tels quels par les segmented controls de la maquette. */
export const RUM_TYPE_LABELS = {
    AGRICOLE: 'Agricole',
    MELASSE: 'Mélasse',
    PUR_JUS: 'Pur jus',
    AUTRE: 'Autre',
};
export const RUM_STATUSES = ['TO_TASTE', 'TASTED'];
export const rumStatusSchema = z.enum(RUM_STATUSES);
export const RUM_STATUS_LABELS = {
    TO_TASTE: 'À déguster',
    TASTED: 'Dégusté',
};
export const SESSION_STATUSES = ['PLANNED', 'OPEN', 'CLOSED'];
export const sessionStatusSchema = z.enum(SESSION_STATUSES);
/**
 * Pays proposés au **pronostic à l'aveugle** (écran 05). La saisie reste libre.
 *
 * Ce n'est plus la source des filtres de la Cave : ceux-ci viennent de `GET /rums/countries`,
 * c'est-à-dire des bouteilles réellement présentes, pour qu'un pays ajouté par un membre y
 * apparaisse. Ici la liste reste figée à dessein — un pronostic dont les propositions
 * seraient tirées de la cave soufflerait la réponse, le rhum mystère en faisant partie.
 *
 * Les suggestions de `style` ont disparu avec la même migration : le référentiel les sert
 * désormais, plus aucun écran ne lisait la constante.
 */
export const COUNTRY_SUGGESTIONS = [
    'Jamaïque',
    'Martinique',
    'Barbade',
    'Guadeloupe',
    'Trinité-et-Tobago',
    'Maurice',
    'La Réunion',
    'Cuba',
    'Mexique',
    'Guyana',
    'Venezuela',
    'Philippines',
];
//# sourceMappingURL=enums.js.map